import React, { useContext, useEffect, useState } from 'react'
import { FlatList, Text, View } from 'react-native'
import { TemplatePage } from '../../../components/TemplatePage'
import { globalStyle } from '../../../theme/global'
import { HeaderList } from '../components/HeaderList'
import { ItemList } from '../components/ItemList'
import { Separator } from '../../../components/Separator'
import { DescriptionStates } from '../components/DescriptionStates'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { usePost } from '../../../hooks/usePost'
import { paths } from '../../../api/pathsApi'
import { Item, StateRecord } from '../../../context/Alerts/types'
import { AlertMessage } from '../../../components/AlertMessage'
import { useTranslation } from 'react-i18next'
import { SeaWaterContext } from '../../../context/SeaWater/SeaWaterContext'
import { FreshWaterContext } from '../../../context/FreshWater/FreshWaterContext'
import { Alert401 } from '../../../components/AlertMessage/Alert401'
import { useGetInitialDataByArea } from '../../../hooks/useGetInitialDataByArea'
import { InitialDataFreshWater } from '../../../context/FreshWater/types'
import { InitialDataResponse } from '../../../context/SeaWater/types'
import { useContextApp } from '../../../hooks/useContextApp'
import { Items, RootParams } from '../../../navigator/types'
import { textColor } from '../../../theme/colors'

interface ItemSelectd {
  registerKey: string
  parentKey: string
  item: StateRecord
}

interface Navigate extends StackNavigationProp<RootParams, 'DetailUVFilters'> {}

const FIRST_ELEMENT = 0

export const DetailUVFilters = () => {
  const {
    handleLogOut,
    user: { areaSelected },
    getRecordsByArea,
    deleteRecordStatesAndMortality: deleteRecordByKey,
  } = useContextApp()

  const seaWaterContext = useContext(SeaWaterContext)
  const freshWaterContext = useContext(FreshWaterContext)
  const { navigate } = useNavigation<Navigate>()
  const { t } = useTranslation()
  const [showAlertDelete, setShowAlertDelete] = useState(false)
  const [showAlertSend, setShowAlertSend] = useState(false)
  const [showAlertResponse, setShowAlertResponse] = useState(false)
  const [error401, setError401] = useState<{ code: number | null; msg: string }>({
    code: null,
    msg: '',
  })

  const uvFilterRecords = getRecordsByArea({
    alertType: 'uvFilters',
    areaSelected,
    getArea: (item: Item<StateRecord>) => item.area,
    getRecord: (item: Item<StateRecord>) => item.record,
  })

  const allRecords = uvFilterRecords

  const [selected, setSelected] = useState<{
    [key: string]: ItemSelectd
  }>({})

  const freshWaterData = useGetInitialDataByArea<InitialDataFreshWater>({
    url: paths().SYNC.INITIAL_FRESH,
    enabled: false,
    onSuccess(data) {
      freshWaterContext.handleInittialData(data)
      successFunction()
    },
  })
  const seaWaterData = useGetInitialDataByArea<InitialDataResponse>({
    url: paths().SYNC.INITIAL_SEA,
    enabled: false,
    onSuccess(data) {
      seaWaterContext.handleInittialData(data)
      successFunction()
    },
  })

  const { handleSendData, isLoading } = usePost({
    url: paths().STATES.CHANGE_FILTER_UV,
    onSuccess: () => {
      freshWaterData.getInitialData()
    },
    onError(error) {
      if (error.code === 401) {
        freshWaterContext.handleResetData()
        setError401(error)
      }
    },
  })

  const handleItemSelected = ({ registerKey, parentKey, item }: ItemSelectd) => {
    setSelected((oldSelected) => {
      const { [registerKey]: deleteRecord, ...rest } = oldSelected
      if (deleteRecord) {
        return {
          ...rest,
        }
      }
      return {
        ...oldSelected,
        [registerKey]: { registerKey, parentKey, item },
      }
    })
  }

  const handleShowConfirmDelete = (value: boolean) => setShowAlertDelete(value)
  const handleShowConfirmSend = (value: boolean) => setShowAlertSend(value)
  const handleShowAlertResponse = (value: boolean) => setShowAlertResponse(value)

  const successFunction = () => {
    handleShowAlertResponse(true)
    handleDelete()
    setSelected({})
  }

  const handleDelete = () => {
    const records = Object.values(selected)
    deleteRecordByKey(records, 'uvFilters')
    setSelected({})
  }

  const handleSend = () => {
    const listSend = Object.values(selected).map(({ item }) => ({
      uvfilterId: item.levelThreeId,
      stateId: item.stateId,
    }))

    handleSendData(listSend)
  }

  const handleShow = () => {
    const record = Object.values(selected)[FIRST_ELEMENT]?.item

    if (record) {
      const cages: Items[] = allRecords
        .filter(
          (item) => item.levelOneId === record.levelOneId && item.levelTwoId === record.levelTwoId,
        )
        .map((item) => ({
          levelThreeId: item.levelThreeId,
          stateName: item.newState,
          stateId: item.stateId,
        }))

      navigate('UVFilter', {
        levelOneId: record.levelOneId,
        currentState: record.currentState,
        levelTwoId: record.levelTwoId,
        levelThreeName: record.levelThreeName,
        newState: record.newState,
        items: cages,
      })
    }
  }

  useEffect(() => {
    if (allRecords.length === 0) navigate('Alerts')
  }, [allRecords])

  return (
    <TemplatePage styleContent={{ padding: 0, marginBottom: 0 }} header title={'ALERTAS'}>
      <View style={globalStyle.viewContainer}>
        <FlatList
          data={allRecords}
          renderItem={({ item, index }) => (
            <ItemList
              key={index}
              parentKey={item.parentKey}
              registerKey={item.registerKey}
              date={item.dateTime}
              name={item.levelThreeName}
              item={item}
              isCheck={!!selected[item.registerKey]}
              getItemValue={(value) => handleItemSelected(value)}
            >
              <DescriptionStates currentState={item.currentState} newState={item.newState} />
            </ItemList>
          )}
          ListHeaderComponent={() => (
            <HeaderList
              onPressDelete={() => handleShowConfirmDelete(true)}
              onPressSend={() => handleShowConfirmSend(true)}
              onPressShow={handleShow}
              sendingLoader={isLoading || freshWaterData.isLoading || seaWaterData.isLoading}
              numberOfSelectedRecords={Object.values(selected).length}
            />
          )}
          ItemSeparatorComponent={() => <Separator />}
        />
      </View>
      <Alert401 isRender={error401.code === 401} action={handleLogOut} />

      {showAlertDelete && (
        <AlertMessage
          title={t('Eliminar registros')}
          action={() => handleDelete()}
          cancelButton
          actionCancelButton={() => handleShowConfirmDelete(false)}
        >
          <Text style={{ textAlign: 'center', color: textColor }}>
            {t('¿Estás seguro de eliminar los registros seleccionados?')}
          </Text>
        </AlertMessage>
      )}

      {showAlertSend && (
        <AlertMessage
          title={t('Enviar')}
          action={() => {
            handleSend()
            handleShowConfirmSend(false)
          }}
          cancelButton
          actionCancelButton={() => handleShowConfirmSend(false)}
        >
          <Text style={{ textAlign: 'center', color: textColor }}>
            {t('¿Estás seguro de enviar los registros seleccionados?')}
          </Text>
        </AlertMessage>
      )}

      {showAlertResponse && (
        <AlertMessage
          title={t('Solicitud Exitosa')}
          action={() => {
            handleShowAlertResponse(false)
          }}
        >
          <Text style={{ textAlign: 'center', color: textColor }}>
            {t('Formulario enviado correctamente')}
          </Text>
        </AlertMessage>
      )}
    </TemplatePage>
  )
}
